const fragment = `
  id
  name
  basePrice
  description
  defaultImageUrl  
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listPalettesQuery = `
  query ListPalettes(
    $filter: PaletteFilterInput
  ) {
    items: listPalettes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getPaletteQuery = `
  query GetPalette($id: Int!) {
    item: getPalette(id: $id) {
      ${fragment}
    }
  }
`;

export const createPaletteQuery = `
  mutation CreatePalette(
    $input: CreatePaletteInput!
  ) {
    item: createPalette(input: $input) {
      ${fragment}
    }
  }
`;

export const updatePaletteQuery = `
  mutation UpdatePalette(
    $input: UpdatePaletteInput!
  ) {
    item: updatePalette(input: $input) {
      ${fragment}
    }
  }
`;

export const deletePaletteQuery = `
  mutation DeletePalette(
    $id: Int!
  ) {
    item: deletePalette(id: $id) {
      ${fragment}
    }
  }
`;
